import { UsersIcon, CollectionIcon } from '@heroicons/vue/outline'

export default function useCustomerNavigation() {
  return {
    overviewTitle: 'Customer Center',
    overviewRouteName: 'web.company.customer-overview.show',
    sections: [
      {
        show: true,
        name: 'Manage',
        description:
          'Manage your customers and organize them into groups to easily manage complex pricing and billing configurations as your business grows.',
        children: [
          {
            show: true,
            name: 'Customer List',
            description: 'All the customers you service.',
            routeIsInertia: true,
            targetRouteName: 'web.company.customers.index',
            icon: UsersIcon,
            routeNamesToCheckIfCurrent: ['web.company.customers.*']
          },
          {
            show: true,
            name: 'Customer Groups',
            description:
              'Brokerages, offices, teams, or other groupings of customers that share pricing and billing settings.',
            routeIsInertia: true,
            targetRouteName: 'web.company.customer-groups.index',
            icon: CollectionIcon,
            routeNamesToCheckIfCurrent: ['web.company.customer-groups.*']
          }
        ]
      }
    ]
  }
}
